<template>
  <div class="lab-settings">
    <b-container fluid>
      <b-row>
        <!-- LEFT TAB LIST -->
        <b-col md="2">
          <b-list-group>
            <b-list-group-item v-for="(tab, index) in labSettingTabs" :key="index" :active="currentTab === index"
              @click="loadTab(tab.component, index)">
              {{ index + 1 }}) {{ tab.name }}
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <!-- RIGHT CONTENT -->
        <b-col md="10">
          <component :course_id="course_id" :is="currentComponent" :selectedInstitute="selectedInstitute" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import ExperimentEvaluationParameters from "./ExperimentEvaluationParameters.vue";
import LaboratoryContinuousEvaluation from "./LaboratoryContinuousEvaluation.vue";
import LaboratoryInternalExam from "./LaboratoryInternalExam.vue";
import AdditionalEvaluation from "./AdditionalEvaluation.vue";

export default {
  props: ["course_id"],

  components: {
    ExperimentEvaluationParameters,
    LaboratoryContinuousEvaluation,
    LaboratoryInternalExam,
    AdditionalEvaluation, 
  },

  data() {
    return {
      currentTab: 0,
      currentComponent: "ExperimentEvaluationParameters",

      labSettingTabs: [
        {
          name: "Experiment & Evaluation Parameters",
          component: "ExperimentEvaluationParameters",
        },
        {
          name: "Laboratory Continuous Evaluation",
          component: "LaboratoryContinuousEvaluation",
        },
        {
          name: "Laboratory Internal Exam",
          component: "LaboratoryInternalExam",
        },
        {
          name: "Additional Evaluation Components",              
          component: "AdditionalEvaluation",
        },
      ],
    };
  },

  methods: {
    loadTab(component, index) {
      this.currentTab = index;
      this.currentComponent = component;
    },
  },
};
</script>
